export default {
  props: {
    is__hidden: [String, Boolean]
  }
}
